export const TEST_ID = 'wideContentContainer';
